import { inject, type Ref } from 'vue';
import type { SerializedUser } from '@/api/users';
import { wallClock } from '@/utils/medications';

// "Now" in the company time zone, where the server reads the date-times the
// web app sends: a browser in another zone still schedules in company time.
export function useCompanyClock() {
  const currentUser = inject<Ref<SerializedUser> | undefined>('currentUser', undefined);

  // An instant (e.g. a saved order's end) as the company clock reads it.
  function companyTime(date: Date): Date {
    return wallClock(date, currentUser?.value?.companyTimeZone);
  }

  function now(): Date {
    return companyTime(new Date());
  }

  return { now, companyTime };
}
